import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "account-selector-desktop" };
const _hoisted_2 = {
    key: 0,
    class: "pill-stack"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
    key: 0,
    class: "pill-stack-counter overlap"
};
const _hoisted_5 = { class: "pill-content" };
const _hoisted_6 = { class: "pill-meta" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
    key: 0,
    class: "pill-stack"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
    key: 0,
    class: "pill-stack-counter overlap"
};
const _hoisted_11 = { class: "pill-content" };
const _hoisted_12 = { class: "pill-label" };
const _hoisted_13 = { class: "pill-meta" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["src"];
const _hoisted_16 = { class: "pill-content" };
const _hoisted_17 = { class: "pill-label" };
const _hoisted_18 = { class: "pill-meta" };
const _hoisted_19 = { key: 0 };
import { computed } from 'vue';
import { useAppState } from '@/composables/useAppState';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccountSelectorDesktop',
    props: {
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props) {
        const state = useAppState();
        function cleanBrandName(name) {
            if (!name)
                return '';
            const map = { 'ø': 'o', 'Ø': 'O', 'æ': 'ae', 'Æ': 'AE', 'ß': 'ss', 'ð': 'd', 'Ð': 'D', 'þ': 'th', 'Þ': 'Th', 'đ': 'd', 'Đ': 'D', 'ł': 'l', 'Ł': 'L' };
            let ret = name.replace(/[ /]/g, '+');
            ret = ret.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^\x20-\x7E]/g, c => map[c] || '');
            return encodeURIComponent(ret);
        }
        function getBrandLogoUrl(name) {
            if (!name)
                return require('@/assets/round3.png');
            return 'https://api.sysodev.link/BrandLogos/' + cleanBrandName(name);
        }
        function getAvatarUrl(account) {
            return account.bank?.logoUri || getBrandLogoUrl(account.bank?.name);
        }
        const accountGroups = computed(() => {
            const accounts = (state.bankInfo?.accounts || []).filter((a) => a.source === 0);
            const groups = {
                current: { label: 'Current', accounts: [] },
                credit: { label: 'Credit', accounts: [] },
                savings: { label: 'Savings', accounts: [] },
            };
            for (const a of accounts) {
                const type = a.accountType?.prettyName;
                if (type === 'Current')
                    groups.current.accounts.push(a);
                else if (type === 'Credit')
                    groups.credit.accounts.push(a);
                else if (type === 'Savings')
                    groups.savings.accounts.push(a);
            }
            return Object.entries(groups)
                .filter(([, g]) => g.accounts.length > 0)
                .map(([type, g]) => ({
                type,
                label: g.label,
                accounts: g.accounts,
                avatarStack: g.accounts.slice(0, 3).map(a => getAvatarUrl(a)),
                overflowCount: Math.max(0, g.accounts.length - 3),
            }));
        });
        const flatAccounts = computed(() => (state.bankInfo?.accounts || []).filter((a) => a.source === 0));
        const totalAccounts = computed(() => flatAccounts.value.length);
        const allStack = computed(() => ({
            urls: flatAccounts.value.slice(0, 3).map((a) => getAvatarUrl(a)),
            overflowCount: Math.max(0, flatAccounts.value.length - 3),
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                    class: _normalizeClass(['account-pill', { active: _ctx.modelValue === 'all' }]),
                    onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('update:modelValue', 'all')))
                }, [
                    (allStack.value.urls.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allStack.value.urls, (url, i) => {
                                return (_openBlock(), _createElementBlock("img", {
                                    key: i,
                                    class: _normalizeClass(["pill-stack-avatar", { overlap: i > 0 }]),
                                    src: url,
                                    onError: _cache[0] || (_cache[0] = ($event) => ($event.target.src = require('@/assets/round3.png')))
                                }, null, 42, _hoisted_3));
                            }), 128)),
                            (allStack.value.overflowCount > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, " +" + _toDisplayString(allStack.value.overflowCount), 1))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_5, [
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "pill-label" }, "All Accounts", -1)),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(totalAccounts.value) + " account" + _toDisplayString(totalAccounts.value === 1 ? '' : 's'), 1)
                    ])
                ], 2),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountGroups.value, (group) => {
                    return (_openBlock(), _createElementBlock("button", {
                        key: group.type,
                        class: _normalizeClass(['account-pill', { active: _ctx.modelValue === group.type }]),
                        onClick: ($event) => (_ctx.$emit('update:modelValue', group.type))
                    }, [
                        (group.avatarStack.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.avatarStack, (url, i) => {
                                    return (_openBlock(), _createElementBlock("img", {
                                        key: i,
                                        class: _normalizeClass(["pill-stack-avatar", { overlap: i > 0 }]),
                                        src: url,
                                        onError: _cache[2] || (_cache[2] = ($event) => ($event.target.src = require('@/assets/round3.png')))
                                    }, null, 42, _hoisted_9));
                                }), 128)),
                                (group.overflowCount > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, " +" + _toDisplayString(group.overflowCount), 1))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(group.label), 1),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(group.accounts.length) + " account" + _toDisplayString(group.accounts.length === 1 ? '' : 's'), 1)
                        ])
                    ], 10, _hoisted_7));
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(flatAccounts.value, (account) => {
                    return (_openBlock(), _createElementBlock("button", {
                        key: account.id,
                        class: _normalizeClass(['account-pill', { active: _ctx.modelValue === account.id }]),
                        onClick: ($event) => (_ctx.$emit('update:modelValue', account.id))
                    }, [
                        _createElementVNode("img", {
                            class: "pill-avatar",
                            src: getAvatarUrl(account),
                            onError: _cache[3] || (_cache[3] = ($event) => ($event.target.src = require('@/assets/round3.png')))
                        }, null, 40, _hoisted_15),
                        _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(account.bank?.name || 'Account'), 1),
                            _createElementVNode("span", _hoisted_18, [
                                _createTextVNode(_toDisplayString(account.accountType?.prettyName || '') + " ", 1),
                                (account.accountNumber)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, " · ••••" + _toDisplayString(account.accountNumber.slice(-4)), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ], 10, _hoisted_14));
                }), 128))
            ]));
        };
    }
});
